module.exports = __webpack_public_path__ + "img/asc_act.2d52d35.png";